




















import Vue from 'vue';
export default Vue.extend({
  props: {
    value: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      required: false
    },

    hint: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      inputFocus: false
    };
  },

  computed: {
    enabled(): boolean {
      return !this.disabled;
    }
  },

  methods: {
    onShiftEnter() {
      this.$emit('shift-enter', this.value);
    },
    clear() {
      this.update('');
    },
    update(value: string) {
      this.$emit('update', value);
    },
    setFocus(focus: boolean) {
      this.inputFocus = focus;
      this.$emit('focus-change', focus);
    }
  }
});
